export const DISCOUNT_TYPES = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT',
} as const;

export type DiscountType = (typeof DISCOUNT_TYPES)[keyof typeof DISCOUNT_TYPES];

export interface PromoCodeProps {
  sessionId: string;
  appliedPromoCode?: {
    code: string;
    discountType: DiscountType;
    discountValue: number;
  } | null;
}
